<template>
  <div>
    <!-- DAU -->
    <Echart
      :options="options"
      id="bottomLeftChart"
      height="480px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data () {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
 computed:{
   
 },
  
  methods:{
   formatter(params) {
        let values1 = this.cdata.counts[0].c
        let values2 = this.cdata.counts[1].c
        let values3 = this.cdata.counts[2].c
        return `${params[0].name}<br />${params[0].seriesName}: ${params[0].value} (${values1>0?(params[0].value/values1*100).toFixed(1):0}%)
      <br />${params[1].seriesName}: ${params[1].value} (${values2>0?(params[1].value/values2*100).toFixed(1):0}%)
      <br />${params[2].seriesName}: ${params[2].value} (${values3>0?(params[2].value/values3*100).toFixed(1):0}%)`
      }
  },
  watch: {
    cdata: {
      handler (newData) {
        this.options = {
          tooltip: {
              trigger: 'axis',
              formatter:this.formatter ,
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: '#999'
                }
              }
            },
            toolbox: {
              feature: {
                dataView: {
                  show: true,
                  readOnly: false
                },
                magicType: {
                  show: true,
                  type: ['line', 'bar']
                },
                restore: {
                  show: true
                },
                saveAsImage: {
                  show: true
                }
              }
            },
            legend: {
              data: ["普通用户", '医生', '心理医生']
            },
            xAxis: [{
              type: 'category',
              data: newData.times,
              axisPointer: {
                type: 'shadow'
              }
            }],
            yAxis: [{
                type: 'value',
                name: 'Precipitation',
                min: 0,
                // max: 250,
                interval: 50,
                axisLabel: {
                  formatter: '{value} '
                }
              },
             
            ],
            series: newData.list
        }
      },
      immediate: true,
      deep: true
    },
  },
}
</script>